import React from 'react';
import classnames from 'classnames';
import s from './IconWrap.scss';
export var IconSize;
(function(IconSize) {
    IconSize[/** 8px */ "NANO"] = 'nano';
    IconSize[/** 12px */ "TINY"] = 'tiny';
    IconSize[/** 16px */ "SMALLER"] = 'smaller';
    IconSize[/** 18px */ "SMALL"] = 'small';
    IconSize[/** 20px */ "COMPACT"] = 'compact';
    IconSize[/** 24px */ "MEDIUM"] = 'medium';
    IconSize[/** 32px */ "LARGE"] = 'large';
    IconSize[/** 36px */ "BIG"] = 'big';
    IconSize[/** 48px */ "HUGE"] = 'huge';
    IconSize[/** 96px */ "MEGA"] = 'mega';
})(IconSize || (IconSize = {}));
export var IconPixelSize;
(function(IconPixelSize) {
    IconPixelSize[IconPixelSize["NANO"] = 8] = "NANO";
    IconPixelSize[IconPixelSize["TINY"] = 12] = "TINY";
    IconPixelSize[IconPixelSize["SMALLER"] = 16] = "SMALLER";
    IconPixelSize[IconPixelSize["SMALL"] = 18] = "SMALL";
    IconPixelSize[IconPixelSize["COMPACT"] = 20] = "COMPACT";
    IconPixelSize[IconPixelSize["MEDIUM"] = 24] = "MEDIUM";
    IconPixelSize[IconPixelSize["LARGE"] = 32] = "LARGE";
    IconPixelSize[IconPixelSize["BIG"] = 36] = "BIG";
    IconPixelSize[IconPixelSize["HUGE"] = 48] = "HUGE";
    IconPixelSize[IconPixelSize["MEGA"] = 96] = "MEGA";
})(IconPixelSize || (IconPixelSize = {}));
const IconWrap = ({ className , size =IconSize.MEDIUM , withPadding =false , condensed , customSizable =false , children , verticalAlign , disableDefaultColors , 'aria-hidden': ariaHidden , 'aria-label': ariaLabel , onAnimationEnd , containerRef  })=>/*#__PURE__*/ React.createElement("span", {
        className: classnames(s['root'], !customSizable && s[size], withPadding && s['withPadding'], condensed && s['condensed'], verticalAlign && s[`vertical-align-${verticalAlign}`], !disableDefaultColors && s['default-colors'], className),
        "aria-hidden": ariaHidden,
        "aria-label": ariaLabel,
        onAnimationEnd: onAnimationEnd,
        ref: containerRef
    }, children);
IconWrap.displayName = 'IconWrap';
export default IconWrap;
